module.exports = __webpack_public_path__ + "media/images/lb/280-980ec6b0c617e3123e9f0e399cae498b.svg";